import React, { useEffect, useState } from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import { faArrowLeftLong, faCircleUser, faEllipsisVertical, faHome, faMagnifyingGlass, faRightFromBracket, } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './dashboard.css'
import PlansV2 from '../Plans/PlansV2';
import { Link } from 'react-router-dom';
import CurrentUpcommingPlans from './CurrentUpcommingPlans';
import CancelInvoiceModal from '../CancelInvoiceModal';
import Header from '../Header';
import axios from 'axios';
import { clearSession, logoutRedirectPath } from '../../utils/entryFlow';
function Dashboard() {
    const userLogOut = () => {
        clearSession(); // remove all (keeps the /weekly entry marker)
        window.location.href = logoutRedirectPath();
    }
    // const [currentplandData, setCurrentPlanData] = useState([])
    const [paymentMade, setIsPaymentMade] = useState(false)
    const [showModal, setShowModal] = useState(false); // 👈 for modal control
    const downInvoiceCancelSub = () => {
        setShowModal(true)
    }
    useEffect(() => {
        const width = window.innerWidth
        currentUpcommingPlans();
        /*  if(width > 768)
         {
             setCurrentPlan(true)
             setUpcommingPlan(true)
         } */
        // alert(width)
    }, [])
    const currentUpcommingPlans = async () => {
        try {
            const data = JSON.stringify({
                'user_id': localStorage.getItem('dastaan__user_id') != null ? localStorage.getItem('dastaan__user_id') : 0
            });
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${process.env.REACT_APP_API_URL}/current-upcoming-plans`,
                headers: {
                    'Authorization': localStorage.getItem('dastaan__token'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios.request(config).then((response) => {
                console.log(response.data.data);
                setIsPaymentMade(response.data?.data?.payment_made)
                // setCurrentPlanData(response.data?.data?.current_plan)
                // setUpcommingPlanData(response.data?.data?.upcoming_plans)
            })
        } catch (error) {
        }
    }
    const dw = window.innerWidth
    return (<>
        <div className={`main-container ${dw > 768 ? 'ml-10' : ''} ${dw > 768 ? 'mt-2' : 'mt-10 '}`}>
            <Row className=' mt-5'>
                <Col md={6} xs={6}>
                    <Link to="/my-space">
                        <FontAwesomeIcon className={'text-white'} icon={faArrowLeftLong} />
                        &nbsp;&nbsp;<span className='text-white'>Dashboard</span>
                    </Link>
                </Col>
                {
                    paymentMade === true && (
                        <>
                            <Col md={6} xs={6} className='align-right' onClick={downInvoiceCancelSub}>
                                <FontAwesomeIcon className={'text-white'} icon={faEllipsisVertical} />
                            </Col>
                        </>
                    )}
            </Row>
            <CurrentUpcommingPlans />
            <CancelInvoiceModal show={showModal} onClose={() => setShowModal(false)} />
        </div>
    </>
    )
}
export default Dashboard